import {Modal as BaseModal, ModalProps} from './modal';
import {Body, BodyProps} from './body';
import {Header, HeaderProps} from './header';
import {Footer, FooterProps} from './footer';
import {ManagerWrapperProps} from './with-modal-manager';

import styles from './modal.module.less';

export * from './modal-layer-manager';
export * from './modal-manager';
export * from './modal-context';
export * from './title';
export * from './use-modal';

export * from './close-icon';
export * from './help-link';

type ModalBundleT = typeof BaseModal & {
	Header: typeof Header,
	Body: typeof Body,
	Footer: typeof Footer,
}

const ModalBundle: ModalBundleT = BaseModal as unknown as ModalBundleT;

ModalBundle.Header = Header;
ModalBundle.Body = Body;
ModalBundle.Footer = Footer;

const ModalTheme = {
	header: {
		blueHeader: styles.blueHeader,
	},
};

type ModalFullProps = ModalProps & ManagerWrapperProps;

export {ModalBundle as Modal, ModalFullProps as ModalProps, ModalTheme, type BodyProps, type HeaderProps, type FooterProps};
